import * as React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { generatePath } from 'react-router';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { getPermitByID, getPermits, getProjectPermits, updatePermit } from '../../api/permits';
import { getProjectByID } from '../../api/projects';
import { getContactTypeList } from '../../api/contactType';
import { createUser, getUsers, getUsersByProject, getUsersCustom } from '../../api/users';
import { getJurisdictions } from '../../api/jurisdiction';
import ProjectEditForm from '../../forms/ProjectEditForm';
import { getVocabulariesDataList } from '../../api/vocabulary';

import DashboardLayout from '../../layouts/DashboardLayout';
import PermitContentBlock from '../../organisms/PermitContentBlock';
import ActionPanelPermit from '../../organisms/ActionsPanelPermit';
import PermitMenu from '../../organisms/PermitMenu';
import { GET_ALL_QUERY_PARAMS } from '../../constants';
import { LoaderWithContainer, ModalDefaultDraggable } from '../../molecules';
import PermitForm from '../../forms/PermitForm';
import { USER_TYPES_VALUES } from '../../constants/forms';
import useTablePage from '../../hooks/useTablePage';
import UsersForm from '../../forms/UsersForm';
import SubPermitMenu from '../../organisms/SubPermitMenu';
import AddPermitForm from '../../forms/AddPermitForm';
import { ROUTES } from '../../constants/routes';
import ModalInfo from '../../molecules/ModalInfo';
import PermitViewContacts from '../../organisms/PermitViewContacts';
import useDidUpdateEffect from '../../hooks/useDidUpdate';
import DownloadingPopup from '../../organisms/DownloadAllInspectionsForms/DownloadingPopup';
import { RootState } from '../../redux/root';
import { setIsViewContactsModal, setPermitContacts, setSelectedPermit } from '../../redux/slices/projectSlice';
import { PERMIT_MENU_ACTIVE_TAB } from '../../constants/permitMenu';
import { someDocumentsSelected } from '../../utils/documentsUtil';
import { downloadAllPermitDocumentsCommaSeparatedIds } from '../../api/projectDocuments';
import { DOCUMENTS_TASK_SHEET, setHistoryCameFrom } from '../../redux/slices/documentsSlice';
import SubPermitMenuPartialPayment from '../../organisms/SubPermitMenuPartialPayment';

const processes = [
  {
    title: 'New',
    subProcesses: [{ title: 'New', id: 23 }],
    statuses: [23],
  },
  {
    title: 'Proposal',
    subProcesses: [
      { title: 'Proposal Sent', id: 24 },
      { title: 'Proposal Approved', id: 25 },
    ],
    statuses: [24, 25],
  },
  {
    title: 'In Progress',
    subProcesses: [
      { title: 'Review Approved', id: 26 },
      { title: 'Permit Submitted', id: 27 },
      { title: 'Permit Issued', id: 28 },
      { title: 'Inspection Started', id: 29 },
      { title: 'Payment Pending', id: 30 },
      { title: 'Hold', id: 32 },
    ],
    statuses: [26, 27, 28, 29, 30, 32],
  },
  {
    title: 'Completed',
    subProcesses: [
      { title: 'Completed', id: 31 },
      { title: 'Withdrawn', id: 33 },
    ],
    statuses: [31, 33],
  },
];

const PermitPage = ({ searchPermitId = null, searchProjectId = null }) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [isAddDocument, setAddDocument] = React.useState(false);
  const [showReviewCommentLtr, setShowReviewCommentLtr] = React.useState(false);

  const [isDownloadAllDocs, setDownloadAllDocs] = React.useState(false);
  const [isDocsAvailable, setDocsAvailable] = React.useState(false);
  const [isDocsWaitingOnClient, setDocsWaitingOnClient] = React.useState(false);
  const [disableSend, setDisableSend] = React.useState(false);
  const [isSendDocs, setSendDocs] = React.useState(false);
  const [selectedDocWork, setSelectedDocWork] = React.useState(null);
  const [selectedDocBuilding, setSelectedDocBuilding] = React.useState(null);
  const [activityTypes, setActivityTypes] = React.useState([]);
  const [activityValue, setActivityValue] = React.useState(null);
  const [activityCreated, setActivityCreated] = React.useState(false);

  const [createdPermit, setCreatedPermit] = React.useState(false);
  const [isLocked, setLocked] = React.useState(false);
  const selectedPermit = useSelector((s: RootState) => s.projectsSlice.selectedPermit);
  const historyCameFrom = useSelector((s: RootState) => s.documents.historyCameFrom);
  const showPartialPaymentPopup = useSelector((s: RootState) => s.fees.showPartialPaymentPopup);
  const [cameFromSearch, setCameFromSearch] = React.useState(false);
  const [disableReviewCommentBtn, setDisableReviewCommentBtn] = React.useState(false);
  const isPermitCompleted = () => {
    // this is the case where NOTES tab is active
    if (activeTab === 14) {
      return false;
    }
    return !!(initialValues?.status?.label === 'Completed' || initialValues?.status?.label === 'Withdrawn');
  };
  const history = useHistory();

  const { permitId, projectId } = useParams();

  const [permitGlobalSearch, setPermitGlobalSearch] = React.useState(false);

  useEffect(() => {
    if (historyCameFrom === DOCUMENTS_TASK_SHEET) {
      dispatch(setHistoryCameFrom(''));
      setActiveTab(PERMIT_MENU_ACTIVE_TAB.DOCUMENTS);
    }
  }, [historyCameFrom]);
  React.useEffect(() => {
    if (history.location?.state?.from === 'searchIntoFees') {
      setActiveTab(PERMIT_MENU_ACTIVE_TAB.FEES);
    } else if (history.location?.state?.from === 'globalSearchPage') {
      setPermitGlobalSearch(true);
    } else {
      setPermitGlobalSearch(false);
    }

    const loadPermitById = async () => {
      const result = await getPermitByID(permitId);
      // @ts-ignore
      dispatch(setSelectedPermit(result.data));
    };
    loadPermitById();
  }, []);

  React.useEffect(() => {
    Promise.all([getPermitByID(permitId)]).then(([permitRes]) => {
      if (permitGlobalSearch && (permitRes?.data?.status === 31 || permitRes?.data?.status === 33)) {
        setCameFromSearch(true);
      } else {
        setCameFromSearch(false);
      }
      dispatch(setPermitContacts(permitRes.data.permitContacts));
    });
  }, [selectedPermit]);

  const [isProjectLoading, setProjectLoading] = React.useState(false);
  // Guards the "reshape selectedPermit into form values" effect below: it dispatches
  // setSelectedPermit(initialData), which is one of its own deps, so without this it
  // can re-trigger itself in a tight loop (React #185, "Maximum update depth exceeded").
  // We re-derive at most once per permit id; the save effect clears this so post-save
  // data still refreshes.
  const lastDerivedPermitIdRef = React.useRef<number | null>(null);
  const dispatch = useDispatch();
  const [permits, setPermits] = React.useState(null);
  const [managerData, setManagerData] = React.useState(null);

  const [permitStatus, setPermitStatus] = React.useState(null);
  const [serviceTypes, setServiceTypes] = React.useState(null);
  const [workTypes, setWorkTypes] = React.useState(null);
  const [buildingTypes, setBuildingTypes] = React.useState(null);
  const [initialValues, setInitialValues] = React.useState(null);
  // Full project record + lookups backing the "Edit Project" popup (opened from
  // the EBox card's Edit button on the Permit Details form).
  const [projectRecord, setProjectRecord] = React.useState(null);
  // `building` is a Permit column — Project has no building of its own, and
  // ProjectRetrieveSerializer returns none, so projectRecord.building is always
  // undefined. Every permit under a project shares one building, so the
  // project's existing permits are the source of truth for a new permit's.
  const inheritedBuilding = React.useMemo(
    () =>
      (projectRecord?.permits || [])
        .map(el => el?.building)
        .find(el => el !== null && el !== undefined) ?? null,
    [projectRecord],
  );
  const [projectManagersData, setProjectManagersData] = React.useState([]);
  const [isEditProjectOpen, setEditProjectOpen] = React.useState(false);
  const [editProjectLoading, setEditProjectLoading] = React.useState(false);
  const [editProjectValues, setEditProjectValues] = React.useState({});
  const [jurisdictionsData, setJurisdictionsData] = React.useState([]);
  const [editContactData, setEditContactData] = React.useState([]);
  const [isContactUpdated, setContactUpdated] = React.useState(false);
  const [allContacts, setAllContacts] = React.useState(null);
  const [isFormSaved, setFormSaved] = React.useState(false);
  const [contactTypes, setContactTypes] = React.useState(null);
  const [activeTab, setActiveTab] = React.useState(PERMIT_MENU_ACTIVE_TAB.ACTIVITIES);
  const [activityType, setActivityType] = React.useState(null);

  const [isContactFormSubmitting, setIsContactFormSubmitting] = React.useState(false);

  const [isOpenAddPermitModal, setOpenAddPermitModal] = React.useState(false);

  const [isAddNote, setAddNote] = React.useState(false);
  const [isAddTicket, setAddTicket] = React.useState(false);
  const [isAddInspection, setAddInspection] = React.useState(false);
  const [isAddFees, setAddFees] = React.useState(false);
  const [isFeeSelected, setFeeSelected] = React.useState(false);
  const [isSendingSelectedFees, setIsSendingSelectedFees] = React.useState(false);
  const [isAddCondition, setAddCondition] = React.useState(false);

  const [documentsData, setDocumentsData] = React.useState(null);
  const isViewContactsModal = useSelector((s: RootState) => s.projectsSlice.isViewContactsModal);

  const {
    createOrUpdate,
    isModalOpen,
    handleAdd,
    modalTitle,
    modalError,
    modalSuccess,
    modalErrorTitle,
    handleCloseModal,
    handleCloseModalInfo,
    values,
    errors,
  } = useTablePage({
    createEndpoint: createUser,
    updateEndpoint: updatePermit,
    modalCreateTitle: 'Add Contact',
  });

  const handleCloseForm = () => {
    if (!modalError && !modalSuccess) {
      handleCloseModal();
    }
  };

  const handleCloseAddPermitModal = () => {
    setOpenAddPermitModal(false);
  };

  const tabs = [
    {
      id: PERMIT_MENU_ACTIVE_TAB.ACTIVITIES,
      title: 'Activities',
      action: () => setActiveTab(PERMIT_MENU_ACTIVE_TAB.ACTIVITIES),
    },
    {
      id: PERMIT_MENU_ACTIVE_TAB.INSPECTIONS,
      title: 'Inspections',
      action: () => setActiveTab(PERMIT_MENU_ACTIVE_TAB.INSPECTIONS),
    },
    {
      id: PERMIT_MENU_ACTIVE_TAB.FEES,
      title: 'Fees',
      action: () => setActiveTab(PERMIT_MENU_ACTIVE_TAB.FEES),
    },
    {
      id: PERMIT_MENU_ACTIVE_TAB.NOTES,
      title: 'Notes',
      action: () => setActiveTab(PERMIT_MENU_ACTIVE_TAB.NOTES),
    },
    {
      id: PERMIT_MENU_ACTIVE_TAB.TICKETS,
      title: 'Tickets',
      action: () => setActiveTab(PERMIT_MENU_ACTIVE_TAB.TICKETS),
    },
    {
      id: PERMIT_MENU_ACTIVE_TAB.DOCUMENTS,
      title: 'Documents',
      action: () => setActiveTab(PERMIT_MENU_ACTIVE_TAB.DOCUMENTS),
    },
    {
      id: PERMIT_MENU_ACTIVE_TAB.CONDITIONS,
      title: 'Conditions',
      action: () => setActiveTab(PERMIT_MENU_ACTIVE_TAB.CONDITIONS),
    },
  ];

  const getInitialServiceTypes = (allTypes, currentTypes) => {
    if (currentTypes) {
      const resultTypes = [];
      currentTypes.forEach(el => {
        const type = allTypes.find(typeEl => typeEl.id === el);
        resultTypes.push(type);
      });
      return resultTypes;
    }
    return null;
  };

  const getPermitContacts = (permitContacts, availableContacts) => {
    if (permitContacts) {
      const resultContacts = [];
      const permitUserIds = permitContacts.map(contact => contact.user);
      availableContacts.forEach(contact => permitUserIds.includes(contact.id) && resultContacts.push(contact));
      return resultContacts;
    }
    return null;
  };

  const createInitialValues = (permit, project, currManager) => {
    return {
      name: permit.name,
      number: permit.number,
      total: permit.amount,
      expirationDate: permit?.expirationDate,
      square: permit.squareFeet,
      inspections: permit.inspectionsCount,
      storageBox: permit.storageBox,
      jurisdiction: project.jurisdictionName,
      // EA-1373: auto-generated folder name (e.g. NPL2026080001), read-only.
      folderName: permit.folderName,
      documents: permit?.documents,
      address: project.address,
      eboxConfirmationNumber: project.eboxConfirmationNumber,
      description: permit.description,
      info: permit.info || '',
      folioId: permit.folioId,
      permitLink: permit.permitLink,
      approvedPlans: permit.approvedPlans,
      gateCode: permit.gateCode,
      permitCost: permit.permitCost,
      status: permitStatus
        ?.filter(el => el.id === permit.status)
        .map(el => ({
          value: el.id?.toString(),
          label: el?.title,
        }))[0],
      // permitContacts: getPermitContacts(
      //   permit.permitContacts,
      //   allContacts,
      // ),
      serviceType: getInitialServiceTypes(serviceTypes, permit.serviceType),
      manager: currManager ? `${currManager.firstName} ${currManager.lastName}` : project.managerName,
      work: permit.work
        ? workTypes
            .filter(type => type.id === permit.work)
            .map(el => ({
              value: el.id?.toString(),
              label: el?.title,
            }))[0]
        : null,
      building: permit.building
        ? buildingTypes
            .filter(type => type.id === permit.building)
            .map(el => ({
              value: el.id?.toString(),
              label: el?.title,
            }))[0]
        : null,
      permitIssued: permit.permitIssued,
    };
  };

  React.useEffect(() => {
    setIsLoading(true);
    Promise.all([
      getProjectByID(projectId),
      getPermitByID(permitId),
      getContactTypeList({
        ...GET_ALL_QUERY_PARAMS,
      }),
      getVocabulariesDataList({
        ...GET_ALL_QUERY_PARAMS,
        ordering: 'title',
      }), // permit statuses
    ])
      .then(([projectResponse, permitsResponse, contactTypesResponse, permitStatusResponse]) => {
        // Keep the project around: Add Permit inherits the project's building.
        setProjectRecord(projectResponse.data);
        setPermits([
          ...projectResponse.data.permits,
          {
            name: 'Add new Permit',
            id: Math.random(),
            button: true,
          },
        ]);
        // @ts-ignore
        dispatch(setSelectedPermit(permitsResponse.data));
        setContactTypes(contactTypesResponse.data.results?.filter(el => el?.isActiveStatus === 'True'));
        setPermitStatus(permitStatusResponse.data.results.filter(el => el?.vocabularyEntity === 6));
        setServiceTypes(permitStatusResponse.data.results?.filter(el => el?.isActive && el?.vocabularyEntity === 5));
        setWorkTypes(permitStatusResponse.data.results?.filter(el => el?.isActive && el?.vocabularyEntity === 2));
        setBuildingTypes(permitStatusResponse.data.results?.filter(el => el?.isActive && el?.vocabularyEntity === 1));
        setAllContacts([]);
      })
      .catch(() => {})
      .finally(() => setIsLoading(false));
  }, []);

  useDidUpdateEffect(() => {
    if (isContactUpdated) {
      Promise.all([
        getUsers({
          ...GET_ALL_QUERY_PARAMS,
          userRole: USER_TYPES_VALUES.CLIENT,
        }), // individuals
      ]).then(([individualContactsResponse]) =>
        // companyContactsResponse,
        setAllContacts([
          ...individualContactsResponse.data.results?.filter(el => el?.isActive && (el?.clientType === 2 || el?.clientType === 1)),
        ]),
      );
    }
  }, [isContactUpdated]);

  useDidUpdateEffect(() => {
    if (createdPermit) {
      setIsLoading(true);
      Promise.all([getProjectPermits(projectId)])
        .then(([permitsResponse]) => {
          setInitialValues(null);
          setPermits([
            ...permitsResponse.data,
            {
              name: 'Add new Permit',
              id: Math.random(),
              button: true,
            },
          ]);
          const newPermit = permitsResponse.data.find(
            el =>
              el.id ===
              Math.max.apply(
                null,
                permitsResponse.data.map(permit => permit.id),
              ),
          );
          dispatch(setSelectedPermit(newPermit));
          const path = generatePath(ROUTES.PERMIT, {
            projectId,
            permitId: newPermit.id,
          });
          history.push(path);
        })
        .catch(() => {})
        .finally(() => {
          setIsLoading(false);
          setCreatedPermit(false);
          window.location.reload();
        });
    }
  }, [createdPermit]);

  React.useEffect(() => {
    if (isFormSaved) {
      setIsLoading(true);
      Promise.all([getProjectPermits(projectId), getPermitByID(permitId)])
        .then(([permitsResponse, permitByIdResponse]) => {
          if (projectId) {
            // No client-side project filter here: permit_details is already
            // scoped to ?project_id= (and the caller's franchise) server-side,
            // and its ProjectPermitSerializer does not serialize `project` — so
            // filtering on el.project compared undefined and emptied the permit
            // picker on every save until a full page reload.
            setPermits([
              ...permitsResponse.data,
              {
                name: 'Add new Permit',
                id: Math.random(),
                button: true,
              },
            ]);
            // Use the canonical permit-detail payload (same one the page loads
            // with) as the source of truth — the project/permit_details list
            // endpoint can lag behind a just-saved PATCH, which left the
            // Permit Details form showing pre-save values until a full reload.
            // Clear the derive guard so the reshape effect picks up the fresh data.
            lastDerivedPermitIdRef.current = null;
            dispatch(setSelectedPermit(permitByIdResponse.data));
          }
        })
        .catch(() => {})
        .finally(() => {
          setIsLoading(false);
          setFormSaved(false);
        });
    }
  }, [isFormSaved]);

  useDidUpdateEffect(() => {
    if (selectedPermit && selectedPermit?.project && allContacts && lastDerivedPermitIdRef.current !== selectedPermit.id) {
      lastDerivedPermitIdRef.current = selectedPermit.id;
      setProjectLoading(true);

      Promise.all([
        getProjectByID(+selectedPermit.project),
        getUsers({
          ...GET_ALL_QUERY_PARAMS,
          userRole: USER_TYPES_VALUES.EMPLOYEE,
        }),
      ])
        .then(([projectResponse, managersResponse]) => {
          const currManager = managersResponse.data.results.find(el => el?.id === selectedPermit?.manager);
          const initialData = createInitialValues(selectedPermit, projectResponse.data, currManager);
          setInitialValues(initialData);
          setProjectRecord(projectResponse.data);
          setProjectManagersData(managersResponse.data.results);
          dispatch(setSelectedPermit(initialData));
        })
        .catch(e => {
          console.log(e);
        })
        .finally(() => setProjectLoading(false));
    }
  }, [selectedPermit, allContacts]);

  // Open the "Edit Project" popup from the Permit Details EBox card. Fetches the
  // jurisdiction + contact lookups the form needs, then resolves the project's
  // saved jurisdiction/manager/contacts into the option objects it expects.
  const openEditProject = () => {
    if (!projectRecord) return;
    setEditProjectOpen(true);
    setEditProjectLoading(true);
    Promise.all([getJurisdictions({ ...GET_ALL_QUERY_PARAMS, ordering: 'name' }), getUsersByProject(projectRecord.id)])
      .then(([jurisdictionsResponse, contactsResponse]) => {
        const jurisdictions = jurisdictionsResponse.data.results;
        const contacts = (contactsResponse.data || []).filter(el => el?.isActive);
        setJurisdictionsData(jurisdictions);
        setEditContactData(contacts);
        setEditProjectValues({
          ...projectRecord,
          jurisdiction: jurisdictions.find(el => el.id === projectRecord.jurisdiction),
          manager: projectManagersData.find(el => el.id === projectRecord.manager),
          contacts: contacts.filter(el => projectRecord.contacts?.includes(el.id) || (projectRecord.companyContacts || []).includes(el.id)),
        });
      })
      .catch(e => console.log(e))
      .finally(() => setEditProjectLoading(false));
  };

  // After a successful project edit, re-pull the project so the EBox card and
  // other project-derived fields on this permit reflect the change.
  const refreshAfterProjectEdit = () => {
    if (!projectRecord?.id) return;
    getProjectByID(projectRecord.id)
      .then(projectResponse => {
        setProjectRecord(projectResponse.data);
        setInitialValues(prev => (prev ? { ...prev, eboxConfirmationNumber: projectResponse.data.eboxConfirmationNumber } : prev));
      })
      .catch(e => console.log(e));
  };

  const handlePermitSelect = selected => {
    if (selected?.id === selectedPermit?.id) {
      return null;
    }
    if (selected.button) {
      dispatch(setSelectedPermit(selectedPermit));
      setOpenAddPermitModal(true);
    }
    if (selected && !selected.button) {
      setInitialValues(null);
      dispatch(setSelectedPermit(selected));
      const path = generatePath(ROUTES.PERMIT, {
        projectId,
        permitId: selected.id,
      });
      history.push(path);
    }
    if (!selected) {
      dispatch(setSelectedPermit(null));
    }
    return null;
  };

  const onActivityChange = selectedActivity => {
    setActivityType(selectedActivity);
  };

  const handleCloseViewContactsForm = () => {
    dispatch(setIsViewContactsModal(false));
  };
  const handleDocumentData = data => {
    setDocumentsData(data);
  };
  const showMergingForms = useSelector((s: RootState) => s.inspections.showMergingForms);
  const mcheckedBoxes = useSelector((s: RootState) => s.documents.mcheckedBoxes);
  const downloadAllDocs = async () => {
    const documents = Object.keys(mcheckedBoxes)
      .reduce((idArr, key) => {
        if (mcheckedBoxes[key]) {
          idArr.push(key);
        }
        return idArr;
      }, [])
      .join(',');

    const result = await downloadAllPermitDocumentsCommaSeparatedIds(documents);
    let fileName = '';
    try {
      fileName = result.data.contentDisposition.split('filename=')[1].replace(/"/g, '');
    } catch (e) {
      fileName = 'files.zip';
    }

    const binaryData = atob(result.data.file);
    const uint8Array = new Uint8Array(binaryData.length);
    for (let i = 0; i < binaryData.length; i++) {
      uint8Array[i] = binaryData.charCodeAt(i);
    }

    const blob = new Blob([uint8Array], { type: 'application/zip' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
  };
  return (
    <DashboardLayout overY>
      {isLoading && <LoaderWithContainer />}
      {!isLoading && selectedPermit && (
        <StickyPermitHeader>
          <div style={{ width: '100%' }}>
            <ActionPanelPermit
              permits={permits}
              permitSelect={handlePermitSelect}
              selectedPermit={selectedPermit}
              processes={processes}
              currentStatus={selectedPermit.status}
            />
          </div>
          <PermitMenu tabs={tabs} activeTab={activeTab} />
          <div style={{ width: '100%' }}>
            {showMergingForms && <DownloadingPopup />}
            {showPartialPaymentPopup && <SubPermitMenuPartialPayment />}
            <SubPermitMenu
              activeTab={activeTab}
              onActivityChange={onActivityChange}
              permit={permitId}
              selectedPermit={initialValues}
              setAddNote={setAddNote}
              setAddTicket={setAddTicket}
              setAddInspection={setAddInspection}
              setAddFees={setAddFees}
              setActivityCreated={setActivityCreated}
              setAddCondition={setAddCondition}
              isFeeSelected={isFeeSelected}
              setIsSendingSelectedFees={setIsSendingSelectedFees}
              workTypes={workTypes}
              buildingTypes={buildingTypes}
              selectedWork={selectedDocWork}
              selectWork={setSelectedDocWork}
              selectedBuilding={selectedDocBuilding}
              selectBuilding={setSelectedDocBuilding}
              setActivityTypes={setActivityTypes}
              activityTypes={activityTypes}
              setActivityValue={setActivityValue}
              activityValue={activityValue}
              setAddDocument={setAddDocument}
              setDownloadAllDocs={setDownloadAllDocs}
              isDocsAvailable={someDocumentsSelected(mcheckedBoxes)}
              downloadAllDocs={downloadAllDocs}
              isDocsWaitingOnClient={isDocsWaitingOnClient}
              disableSend={disableSend}
              setSendDocs={setSendDocs}
              cameFromSearch={cameFromSearch || isPermitCompleted()}
              setLocked={setLocked}
              isLocked={isLocked}
              documentsData={documentsData}
              disableReviewCommentBtn={disableReviewCommentBtn}
              setShowReviewCommentLtr={setShowReviewCommentLtr}
            />
          </div>
        </StickyPermitHeader>
      )}

      {!isProjectLoading && !isLoading && (
        <>
          <PermitForm
            initialValues={initialValues}
            selectedPermit={selectedPermit}
            projectId={projectId}
            permitStatus={permitStatus}
            allContacts={allContacts}
            serviceTypes={serviceTypes}
            workTypes={workTypes}
            buildingTypes={buildingTypes}
            setFormSaved={setFormSaved}
            isLoading={isLoading}
            contactTypes={contactTypes}
            setIsContactsModalOpen={handleAdd}
            onSubmit={createOrUpdate}
            cameFromSearch={cameFromSearch || isPermitCompleted()}
            activityCreated={activityCreated}
            onEditEbox={openEditProject}
          />
          <PermitContentBlock
            projectId={projectId}
            permit={permitId}
            permitStatus={selectedPermit?.status}
            activeTab={activeTab}
            activityType={activityType}
            isAddNote={isAddNote}
            setAddNote={setAddNote}
            isAddTicket={isAddTicket}
            setAddTicket={setAddTicket}
            setAddInspection={setAddInspection}
            isAddFees={isAddFees}
            isAddInspection={isAddInspection}
            setAddFees={setAddFees}
            activityCreated={activityCreated}
            setActivityCreated={setActivityCreated}
            isAddCondition={isAddCondition}
            setAddCondition={setAddCondition}
            setFeeSelected={setFeeSelected}
            isSendingSelectedFees={isSendingSelectedFees}
            setIsSendingSelectedFees={setIsSendingSelectedFees}
            selectedBuilding={selectedDocBuilding}
            selectedWork={selectedDocWork}
            isAddDocument={isAddDocument}
            setAddDocument={setAddDocument}
            setDocsAvailable={setDocsAvailable}
            setDocsWaitingOnClient={setDocsWaitingOnClient}
            setDisableSend={setDisableSend}
            isDownloadAllDocs={isDownloadAllDocs}
            setDownloadAllDocs={setDownloadAllDocs}
            isSendDocs={isSendDocs}
            setSendDocs={setSendDocs}
            cameFromSearch={cameFromSearch || isPermitCompleted()}
            isLocked={isLocked}
            handleDocumentData={handleDocumentData}
            setDisableReviewCommentBtn={setDisableReviewCommentBtn}
            showReviewCommentLtr={showReviewCommentLtr}
            setShowReviewCommentLtr={setShowReviewCommentLtr}
          />
        </>
      )}

      {isEditProjectOpen && (
        <ModalDefaultDraggable title="Edit Project" onClose={() => setEditProjectOpen(false)}>
          {editProjectLoading && <LoaderWithContainer />}
          {!editProjectLoading && !!Object.keys(editProjectValues).length && (
            <ProjectEditForm
              HandleAddContactModal={() => {}}
              editMode
              initialValues={editProjectValues}
              changeMode={() => {}}
              jurisdiction={jurisdictionsData}
              manager={projectManagersData}
              contacts={editContactData}
              handleCloseEditProject={() => setEditProjectOpen(false)}
              updateTable={refreshAfterProjectEdit}
            />
          )}
        </ModalDefaultDraggable>
      )}

      {isViewContactsModal && (
        <StyledModalDraggable onClose={handleCloseViewContactsForm} title="Permit Contacts" extraWide>
          <PermitViewContacts
            permit={permitId}
            selectedPermit={selectedPermit}
            setContactUpdated={setContactUpdated}
            cameFromSearch={cameFromSearch || isPermitCompleted()}
          />
        </StyledModalDraggable>
      )}

      {isOpenAddPermitModal && (
        <StyledModalDraggable onClose={handleCloseAddPermitModal} title="Add Permit" wide>
          <AddPermitForm
            allContacts={allContacts}
            permitStatus={permitStatus}
            serviceTypes={serviceTypes}
            projectBuilding={inheritedBuilding}
            projectManager={projectRecord?.manager}
            workTypes={workTypes}
            contactTypes={contactTypes}
            managersData={[]}
            setIsContactFormSubmitting={setIsContactFormSubmitting}
            selectedProjectId={projectId}
            close={handleCloseAddPermitModal}
            setCreatedPermit={setCreatedPermit}
          />
        </StyledModalDraggable>
      )}

      {isModalOpen && (
        <StyledModalDraggable onClose={handleCloseForm} title={modalTitle} wide>
          <UsersForm
            setIsContactFormSubmitting={setIsContactFormSubmitting}
            initialValues={values}
            modalError={modalErrorTitle.length > 0}
            initialErrors={errors}
            onSubmit={createOrUpdate}
          />
        </StyledModalDraggable>
      )}

      {(modalSuccess || modalError) && (
        <ModalInfo timeToClose={5000} isError={modalError} onClose={handleCloseModalInfo} errorMsg={modalErrorTitle} />
      )}
    </DashboardLayout>
  );
};

const StyledModalDraggable = styled(ModalDefaultDraggable)`
  height: 100%;
  overflow: inherit;
`;

const StickyPermitHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 4;
  background: var(--neutral-50);
`;

export default PermitPage;
